import React, { useState } from "react";

import {
  Confirm,
  Create,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useNotify,
  useRedirect,
  useSaveContext,
} from "react-admin";
import { useForm } from "react-final-form";

import { logError } from "../../../utils/appUtils";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { UserCreateHelp } from "./UserHelp";
import { AnnouncementForm } from "./AnnouncementForm";

const TenantConfirmingSaveButton = (props) => {
  const { saving, handleSubmitWithRedirect: ctxHandleSubmitWithRedirect } =
    useSaveContext();
  const form = useForm();
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingRedirect, setPendingRedirect] = useState();

  const submitWithRedirect =
    props.handleSubmitWithRedirect || ctxHandleSubmitWithRedirect;

  const triggerSubmit = (redirectTo) => {
    const values = form?.getState?.()?.values || {};
    if (values.active === "true" && !values.tenantId) {
      setPendingRedirect(redirectTo);
      setShowConfirm(true);
      return;
    }
    submitWithRedirect?.(redirectTo);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    submitWithRedirect?.(pendingRedirect);
  };

  const handleClose = () => setShowConfirm(false);

  return (
    <>
      <SaveButton
        {...props}
        saving={saving}
        handleSubmitWithRedirect={triggerSubmit}
      />
      <Confirm
        isOpen={showConfirm}
        title="No Tenant Selected"
        content="No tenant is selected. Proceed to save this announcement?"
        onConfirm={handleConfirm}
        onClose={handleClose}
      />
    </>
  );
};

export const AnnouncementCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [saving, setSaving] = useState(false);

  const transform = (data) => {
    setSaving(true);

    data.activatedAt = new Date();

    return data;
  };

  const onSuccess = (data) => {
    setSaving(false);
    notify(`Announcement created successfully.`);
    redirect("/announcements");
  };

  const onFailure = (error) => {
    setSaving(false);
    logError("announcements:AnnouncementCreate:onFailure", error, notify);
  };

  const CreateActions = ({ basePath }) => (
    <TopToolbar>
      <HelpButton>
        <UserCreateHelp {...props} />
      </HelpButton>
      <BackButton basePath={basePath} />
    </TopToolbar>
  );

  const CreateToolbar = (props) => (
    <Toolbar {...props}>
      <TenantConfirmingSaveButton
        label="Save"
        disabled={saving}
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
    </Toolbar>
  );

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Announcement" />}
      actions={<CreateActions />}
    >
      <SimpleForm
        variant="outlined"
        submitOnEnter={false}
        toolbar={<CreateToolbar />}
      >
        <AnnouncementForm />
      </SimpleForm>
    </Create>
  );
};
